import { Step } from "react-joyride";

export const shareModalTutorialSteps: Step[] = [
    // Step 1
    {
        target: ".joyride-share-modal",
        content:
            "This modal allows you to share your image with others and earn you gold for it!",
        placement: "center",
        isFixed: true,
        disableBeacon: true,
    },
    // Step 2
    {
        target: ".joyride-copy-link-button",
        content: "Pressing this will copy the URL to your clipboard.",
        placement: "bottom",
    },
    // Step 3
    {
        target: ".joyride-share-url",
        content:
            "This link contains your referral code, as well as the URL to an image page containing your Image and all the information about it. Share it with others and earn 100 free gold for every person that signs up to CharGen from that link!",
        placement: "bottom",
    },
    // Step 4
    {
        target: ".joyride-share-instructions",
        content:
            "Sharing images on Social Media and tagging us will get you 10 gold per image! Easy way to get free gold without spending a penny!",
        placement: "bottom",
    },
    // Step 5
    {
        target: ".joyride-close-share-modal",
        content: "Close this window to continue.",
        placement: "bottom",
    },
];
